import { ArrowUpRight } from "lucide-react";
import { CtaPanel, Layout, PageIntro } from "../components/Chrome";
import { Reveal } from "../components/Motion";
import { services } from "../data";

export default function Services() {
  return (
    <Layout>
      <PageIntro
        eyebrow="What we do"
        lines={[<>Strategy meets</>, <><em>creator culture.</em></>]}
        text="From first brief to final approval, we make creator partnerships clearer, more considered and easier to activate."
      />
      <section className="service-list section-pad">
        {services.map(([num, title, text], i) => (
          <Reveal as="article" className="service-row" key={title} delay={i * 0.06} y={28} data-testid={`service-${num}`}>
            <span className="service-num">{num}</span>
            <h2>{title}</h2>
            <p>{text}</p>
            <ArrowUpRight className="row-arrow" />
          </Reveal>
        ))}
      </section>
      <CtaPanel eyebrow="A better match starts here" lines={[<>Bring us the brief.</>, <>We’ll bring <em>the people.</em></>]}>Tell Us Your Brief</CtaPanel>
    </Layout>
  );
}
